import { NodeProp } from '@lezer/common';
import { parser } from '@plutojl/lezer-julia';
import { LRLanguage, indentNodeProp, continuedIndent, LanguageSupport } from '@codemirror/language';
import * as autocomplete from '@codemirror/autocomplete';

const juliaLanguage = /*@__PURE__*/LRLanguage.define({
    parser: /*@__PURE__*/parser.configure({
        props: [
            /*@__PURE__*/indentNodeProp.add({
                IfStatement: /*@__PURE__*/continuedIndent({ except: /^\s*(end\b|else\b|elseif\b)/ }),
                TryStatement: /*@__PURE__*/continuedIndent({ except: /^\s*(end\b|else\b|finally\b)/ }),
                "Definition CompoundStatement": /*@__PURE__*/continuedIndent({ except: /^\s*(end\b)/ }), // node groups
                ExportStatement: /*@__PURE__*/continuedIndent(),
                ImportStatement: /*@__PURE__*/continuedIndent(),
                ReturnStatement: /*@__PURE__*/continuedIndent(),
                Assignment: /*@__PURE__*/continuedIndent(),
                BinaryExpression: /*@__PURE__*/continuedIndent(),
                TernaryExpression: /*@__PURE__*/continuedIndent(),
            }),
        ],
    }),
    languageData: {
        closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`", "'''", '"""', "```"] },
        commentTokens: { line: "#", block: { open: "#=", close: "=#" } },
        indentOnInput: /^\s*(\]|\}|\)|end|else|elseif|catch|finally)$/,
    },
});
function collectKeywords() {
    let keywords = [];
    for (let node of parser.nodeSet.types) {
        let groups = node.prop(NodeProp.group);
        let group = groups != null ? groups[0] : null;
        if (group === "keyword") {
            keywords.push({ label: node.name, type: "keyword" });
        }
    }
    return keywords;
}
const keywordCompletion = /*@__PURE__*/juliaLanguage.data.of({
    autocomplete: /*@__PURE__*/autocomplete.completeFromList(/*@__PURE__*/collectKeywords()),
});
const defaultConfig = {
    enableKeywordCompletion: false,
};
function julia(config = defaultConfig) {
    config = Object.assign(Object.assign({}, defaultConfig), config);
    let extensions = [];
    if (config.enableKeywordCompletion) {
        extensions.push(keywordCompletion);
    }
    return new LanguageSupport(juliaLanguage, extensions);
}

export { julia, juliaLanguage, keywordCompletion };
